module.exports = __webpack_public_path__ + "img/centrum-special-coffees.cc27ff72.jpg";